// War HUD entry (GDD §14): the MountHud seam the war screen calls (match/contracts.ts).

import type { MountHud } from '../match/contracts'
import { Hud } from './Hud'

export const mountHud: MountHud = (root, match, picker, settings, palette, signal) => new Hud(root, match, picker, settings, palette, signal)
